import dataScienceIcon from "../images/cards_container_icons/data-science-icon.png";
import machineLearningIcon from "../images/cards_container_icons/machine-learning-icon.jpg";
import featureEngineeringIcon from "../images/cards_container_icons/feature-engineering-icon.png";
import explainableAiIcon from "../images/cards_container_icons/explainable-AI-icon.png";

const cardsData = [
  {
    icon: dataScienceIcon,
    title: "Data Science & Analytics",
    desc: "Advanced statistical modeling, A/B testing, and interactive data visualization to inform strategic business decisions.",
  },
  {
    icon: machineLearningIcon,
    title: "Deep Learning & ML",
    desc: "Algorithm selection, cross-validation and hyperparameter tuning with PyTorch to maximize predictive power.",
  },
  {
    icon: featureEngineeringIcon,
    title: "MLOps & Feature Engineering",
    desc: "Automated feature creation, selection, and dimensionality reduction to boost model performance.",
  },
  {
    icon: explainableAiIcon,
    title: "Ethical AI & Explainability",
    desc: "Bias detection, fairness checks and model interpretability with SHAP/LIME to ensure transparent, ethical decision-making.",
  },
];

export default cardsData;
